export const PROGRAMS_ANNOUNCEMENT_COOKIE_MODAL =
  'enterprise_programs_announcement_modal'
export const PROGRAMS_ANNOUNCEMENT_COOKIE_BANNER =
  'enterprise_programs_announcement_banner'
